<template>
  <div class="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('metatags') }}
      </h1>
      <v-spacer />
    </div>

    <div class="ma-5">
      <v-form @submit.prevent="onSubmit">
        <v-row>
          <v-col cols="12">
            <h4>{{ $t('keywords') }}</h4>
            <v-divider class="mb-3" />
            <v-textarea
              v-model="metatags.keywords"
              :error-messages="metatagValidationErrors['keywords']"
              :label="$t('keywords')"
              rows="1"
              auto-grow
              @input="clearMetatagValidationErrors('keywords')"
            />
          </v-col>
          <v-col cols="12">
            <h4>{{ $t('description') }}</h4>
            <v-divider class="mb-3" />
            <v-textarea
              v-model="metatags.description"
              :error-messages="metatagValidationErrors['description']"
              :label="$t('description')"
              rows="1"
              auto-grow
              @input="clearMetatagValidationErrors('description')"
            />
          </v-col>

          <v-btn :disabled="savingMetatags" type="submit" color="primary" class="ml-3">{{
            $t('save')
          }}</v-btn>
        </v-row>
      </v-form>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Metatags',

  computed: mapState('metatags', ['metatags', 'metatagValidationErrors', 'savingMetatags']),

  created() {
    this.fetchMetatags();
  },

  beforeRouteUpdate(to, from, next) {
    if (
      JSON.stringify(this.metatagFilterParams) !== JSON.stringify(to.query) &&
      to.name === 'metatags'
    ) {
      this.fetchMetatags(to.query);
    }
    next();
  },

  methods: {
    ...mapActions('metatags', ['fetchMetatags', 'updateMetatag', 'clearMetatagValidationErrors']),

    onSubmit() {
      this.updateMetatag(this.metatags);
    },
  },
};
</script>
